<template>
  <div class="container-content">
    <div class="container-content">
      <div class="body-content">
        <p class="sub-title"><a href="/oneStep">一站式查询</a> <span style="margin: 0 4px;">>></span>NQI十三五参与单位查询</p>
        <div class="value"><input type="text" class="input" placeholder="请输入机构名称" v-model="name"><span class="search-btn" @click="search">搜索</span></div>
        <div class="property">
          <div class="property-tit">
            <div class="name">单位性质：</div>
            <div class="tab-nav" v-for="item in this.typeList" :key="item.value">
              <ul>
                <li :class="{'active': rSelect.indexOf(item.value)!=-1}" @click="chooseType(item.value)">{{item.value}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-tit">按地区筛选：</div>
          <area-select
            :data="pcaa"
            size="large"
            :value="innerValue"
            @change="handleChange"
            type="all"
          >
          </area-select>
        </div>
        <div class="map-chart">
          <div id="allmap"></div>
          <div class="box" v-if="resultList.length!==0">
            <div class="title"><div class="zi">搜索结果共{{resultList.length}}条</div></div>
            <div class="result">
              <div class="card" v-for="(item,index) in afterChangeData" :key="item.id" @click="skipToMap(item)">
                <div class="dot">
                  <div class="box2 flex-col">
                    <span class="word11">{{(currentPage-1)*3+index+1}}</span>
                  </div>
                  <div class="name">{{item.name}}</div>
                </div>
                <div class="card-content">
                  <div class="img">
                    <img v-if="item.coverImage" class="card-img" :src="fileUrl +　item.coverImage">
                    <img v-else src="../../assets/images/emptyImg.png" alt="">
                  </div>
                  <div class="right">
                    <div class="address">地址：{{item.address}}</div>
                    <div class="phone">电话：{{item.phone}}</div>
                  </div>
                </div>
              </div>
              <div class="pagination-box" style="position: absolute;bottom: 10px;right: 0;">
                <el-pagination
                  background
                  layout="prev, pager, next, total"
                  :pager-count="pagerCount"
                  :page-size="pagesize"
                  :current-page="currentPage"
                  @current-change="handleCurrentChange"
                  :total="resultList.length">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="project-content" v-if="unitProjectList.length > 0">
          <div class="title">参与项目</div>
          <ul class="project-list">
            <li v-for="(project,index) in unitProjectList" :key="project.id"><router-link :to="'/projectDetail?id=' + project.id" target="_blank">{{index+1}}、{{project.name}}</router-link></li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { BMPGL } from '@/bmpgl.js'
import {pcaa} from 'area-data-vue';
export default {
  name: 'websiteSearch',
  data () {
    return {
      ak: 'stQ9hqOHuBSQhnM84GlZRGFQgicYcdDf',
      BMapGL: null,
      map: null,
      pagesize: 3,
      currentPage: 1,
      pagerCount: 5,
      name: '',
      pcaa: pcaa,
      innerValue: [],
      province: '',
      cityCode: '',
      resultList: [],
      detailsMsg: {},
      fileUrl: 'http://172.172.1.100:90/dataapi/sys/common/static/',
      typeList: [],
      rSelect: [],
      currentValues: '',
      unitProjectList: []
    }
  },
  created () {
    this.fetchunitType();
  },
  mounted () {
    this.initMap();
  },
  updated () {
  },
  computed: {
    // 写在computed里面，每次currentPage发生改变就会执行一次
    afterChangeData () {
      let start = (this.currentPage - 1) * 3;
      let end = this.currentPage * 3;
      return this.resultList.slice(start, end);
    }
  },
  methods: {
    handleChange (values) {
      let code = [];
      code = Object.keys(values[1]);
      this.cityCode = code[0].substring(0, 4);
      this.province = Object.values(values[0]);
      this.fetchResultList();
    },
    // 省市切换
    fetchResultList () {
      this.map.clearOverlays();
      let point = new this.BMapGL.Point(116.404, 39.915);
      this.map.centerAndZoom(point, 5);
      let province = this.province[0];
      this.getBoundary(province);
      let param = {city: this.cityCode, name: this.name, unitTypeList: this.currentValues};
      this.fetch('/dataapi/open/nqi/projectUnit/list', param).then(res => {
        this.resultList = res.result;
        this.currentPage = 1;
        // 循环获取坐标
        for (let item of this.resultList) {
          if (item.address) {
            this.getLocationPoint(item);
          }
        }
      });
    },
    // 搜索机构名称
    fetchName () {
      this.map.clearOverlays();
      let point = new this.BMapGL.Point(116.404, 39.915);
      this.map.centerAndZoom(point, 5);
      let param = {city: this.cityCode, name: this.name, unitTypeList: this.currentValues};
      this.fetch('/dataapi/open/nqi/projectUnit/list', param).then(res => {
        // console.log(res)
        this.resultList = res.result;
        this.currentPage = 1;
        for (let item of this.resultList) {
          if (item.address) {
            this.getLocationPoint(item);
          }
        }
        if (this.resultList.length === 1) {
          this.skipToMap(this.resultList[0])
        }
      });
    },
    // 搜索
    search () {
      this.fetchName()
    },
    handleCurrentChange (value) {
      // console.log(value)
      this.currentPage = value;
    },
    // 获取所有单位性质
    fetchunitType () {
      this.fetch('/dataapi/open/sys/api/queryDictItemsByCode', {code: 'unit_type'}).then(res => {
        // console.log(res)
        this.typeList = res.result;
        // console.log(this.typeList)
      });
    },
    // 选择的单位性质
    chooseType (value) {
      this.map.clearOverlays();
      let point = new this.BMapGL.Point(116.404, 39.915);
      this.map.centerAndZoom(point, 5);
      this.currentValue = value;

      if (this.rSelect.indexOf(value) !== -1) {
        this.rSelect.splice(this.rSelect.indexOf(value), 1); // 取消
      } else {
        this.rSelect.push(value);// 选中添加到数组里
      }
      this.currentValues = '';
      for (let i = 0; i < this.rSelect.length; i++) {
        if (i < this.rSelect.length - 1) {
          this.currentValues += this.rSelect[i] + ',';
        } else {
          this.currentValues += this.rSelect[i];
        }
      }
      // console.log(this.currentValues)
      let param = {city: this.cityCode, name: this.name, unitTypeList: this.currentValues};
      this.fetch('/dataapi/open/nqi/projectUnit/list', param).then(res => {
        this.resultList = res.result;
        this.currentPage = 1;
        for (let item of this.resultList) {
          if (item.address) {
            this.getLocationPoint(item);
          }
        }
      });
    },
    initMap () {
      const _self = this;
      BMPGL(this.ak).then((BMapGL) => {
        _self.BMapGL = BMapGL;
        // 创建地图实例
        _self.map = new BMapGL.Map('allmap');
        let point = new BMapGL.Point(116.404, 39.915);
        _self.map.centerAndZoom(point, 5);
        if (_self.$route.query.name) {
          _self.name = _self.$route.query.name;
          _self.fetchName();
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getLocationPoint (item) {
      const _self = this;
      const BMapGL = _self.BMapGL;
      let myGeo = new BMapGL.Geocoder();
      myGeo.getPoint(item.address, function (point) {
        if (point) {
          let param = {id: item.id};
          _self.fetch('/dataapi/open/nqi/projectUnit/queryById', param).then(res => {
            // console.log(res)
            _self.detailsMsg = res.result;
            item.detail = res.result;
            // 创建信息窗口对象
            let html = `
            <div class="details">
              <h4 class="universityName">${_self.detailsMsg.name || ''}</h4>
              <div class="line"></div>
              <div class="grid">
                <div class="grid1">单位性质：${_self.detailsMsg.unitType || ''}</div>
                <div class="grid2">单位电话：${_self.detailsMsg.phone || ''}</div>
              </div>
              <div class="grid">
                <div class="grid1">城市：${_self.detailsMsg.province || ''}</div>
                <div class="grid2">邮编：${_self.detailsMsg.mail || ''}</div>
              </div>
              <div class="grid">
                <div>电子邮箱：${_self.detailsMsg.email || ''}</div>
              </div>
              <div class="grid">
                <div>单位地址：${_self.detailsMsg.address || ''}</div>
              </div>
              <div class="grid">
                <div>单位网站：<a href="${_self.detailsMsg.webUrl || ''}" target="_blank">${_self.detailsMsg.webUrl || ''}</a></div>
              </div>
              <div class="last">
                <div style="width: 100%">单位简介：${_self.detailsMsg.unitDescription || ''}</div>
              </div>
            </div>`;
            let opts = {
              width: 540, // 信息窗口宽度
              height: 320
            }
            let infoWindow = new BMapGL.InfoWindow(html, opts);
            marker.addEventListener('click', function () {
              _self.map.openInfoWindow(infoWindow, point); // 开启信息窗口
            });
            if (_self.resultList.length === 1) {
              _self.fetchUnitProjectList(_self.detailsMsg.id);
              _self.map.openInfoWindow(infoWindow, point); // 结果只有一条默认打开信息
            }
          });
          let marker = new BMapGL.Marker(point, {title: item.name})
          _self.map.addOverlay(marker);
        } else {
          alert('您选择的地址没有解析到结果！');
        }
      }, '浙江省')
    },
    skipToMap (item) {
      const _self = this;
      const BMapGL = this.BMapGL;
      let myGeo = new BMapGL.Geocoder();
      myGeo.getPoint(item.address, function (point) {
        if (point) {
          let param = {id: item.id};
          _self.fetch('/dataapi/open/nqi/projectUnit/queryById', param).then(res => {
            _self.detailsMsg = res.result;
            // 默认打开提示信息
            let html = `
            <div class="details">
              <h4 class="universityName">${_self.detailsMsg.name || ''}</h4>
              <div class="line"></div>
              <div class="grid">
                <div class="grid1">单位性质：${_self.detailsMsg.unitType || ''}</div>
                <div class="grid2">单位电话：${_self.detailsMsg.phone || ''}</div>
              </div>
              <div class="grid">
                <div class="grid1">城市：${_self.detailsMsg.province || ''}</div>
                <div class="grid2">邮编：${_self.detailsMsg.mail || ''}</div>
              </div>
              <div class="grid">
                <div>电子邮箱：${_self.detailsMsg.email || ''}</div>
              </div>
              <div class="grid">
                <div>单位地址：${_self.detailsMsg.address || ''}</div>
              </div>
              <div class="grid">
                <div>单位网站：<a href="${_self.detailsMsg.webUrl || ''}" target="_blank">${_self.detailsMsg.webUrl || ''}</a></div>
              </div>
              <div class="last">
                <div style="width: 100%">单位简介：${_self.detailsMsg.unitDescription || ''}</div>
              </div>
            </div>`;
            let opts = {
              width: 540, // 信息窗口宽度
              height: 320
            }
            let infoWindow = new BMapGL.InfoWindow(html, opts);
            _self.map.openInfoWindow(infoWindow, point); // 默认打开信息
            _self.fetchUnitProjectList(_self.detailsMsg.id);
            _self.point = new BMapGL.Point(point.lng, point.lat);
            _self.map.centerAndZoom(_self.point, 16);
          })
        } else {
          alert('您选择的地址没有解析到结果！');
        }
      })
    },
    //  绘制面
    getBoundary (area) {
      const _self = this;
      const BMapGL = _self.BMapGL;
      let bd = new BMapGL.Boundary();
      bd.get(area, function (rs) { // 获取行政区域
        let hole = new BMapGL.Polygon(rs.boundaries, {
          strokeWeight: 1, // 设置多边形边线线粗
          strokeColor: '#a0d2e7', // 边线颜色
          strokeOpacity: 0.8,
          fillColor: '#2E5C9A29', // 填充颜色
          fillOpacity: 0.4
        });
        _self.map.addOverlay(hole);
      });
    },
    fetchUnitProjectList () {
      let param = new FormData();
      param.append('unitId', this.detailsMsg.id)
      param.append('pageNo', 1);
      param.append('pageSize', 100);
      this.unitProjectList = [];
      this.post('/dataapi/open/nqi/project/getUnitProjectPage', param).then(res => {
        this.unitProjectList = res.result.records;
      })
    }
  }
}
</script>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 12px auto;
  a {
    color: inherit;
    &:hover {
      text-decoration: none;
    }
  }
  .sub-title {
    padding-top: 12px;
    color: rgba(0, 0, 0, 0.65);
  }
  .value {
    display: flex;
    flex-wrap: wrap;
    margin-top: 43px;
    .input {
      width: 1153px;
      height: 40px;
      background: #FFFFFF;
      border: 1px solid rgba(0, 0, 0, 0.1);
      outline: none;
      padding-left: 8px;
      box-sizing: border-box
    }
    .search-btn {
      width: 127px;
      height: 40px;
      background: #136BAE;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      cursor: pointer;
    }
  }
  .property{
    width: 1280px;
    display: flex;
    align-items: center;
    margin-top: 24px;
    .property-tit{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .name{
        width: 104px;
        height: 20px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
      }
      .tab-nav {
        ul {
          display: flex;
          list-style: none;
          text-align: center;
          li {
            margin: 10px 24px 10px 0;
            background: rgba(0, 0, 0, 0.1);
            cursor: pointer;
            height: 36px;
            line-height: 36px;
            padding: 0 16px;
            transition: all .3s;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
            &:hover {
              background-color: @color-base;
              color: #ffffff;
            }
            &.active {
              background-color: @color-base;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
  .area{
    display: flex;
    align-items: center;
    margin-top: 24px;
    height: 32px;
    .area-tit{
      width: 104px;
      height: 20px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 20px;
    }
  }
  .map-chart {
    margin: 24px 0 80px 0;
    height: 700px;
    position: relative;
    #allmap{
      height: 100%;
    }
    .box{
      .title{
        position: absolute;
        top: 32px;
        left: 24px;
        width: 370px;
        height: 40px;
        background-color: rgba(255, 255, 255, .8);
        .zi{
          margin: 10px 0 10px 16px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
        }
      }
      .result{
        z-index: 5;
        position: absolute;
        top: 76px;
        left: 24px;
        width: 370px;
        height: 554px;
        background-color: rgba(255, 255, 255, .9);
        .pagination-box /deep/ .el-pagination__total{
          display: none;
        }
        .card{
          width: 370px;
          height: 148px;
          margin-bottom: 5px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);;
          &:hover {
            transform:translateY(-2px);
            cursor: pointer;
            box-shadow: 0px 4px 8px 0px rgba(19, 107, 174, 0.1);
            .dot {
              .box2 {
                background: url(../../assets/images/red.png) 100% no-repeat;
              }
            }
          }
          .dot{
            display: flex;
            align-items: center;
            margin-top: 18px;
            margin-left: 20px;
            .box2 {
              display: flex;
              justify-content: center;
              z-index: 169;
              height: 26px;
              background: url(../../assets/images/blue.png)
              100% no-repeat;
              width: 26px;
              align-items: center;
            }
            .word11 {
              z-index: 178;
              display: block;
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 16px;
              font-family: PingFangSC-Medium;
              white-space: nowrap;
              line-height: 22px;
              text-align: justify;
            }
            .name{
              margin-right: 20px;
              margin-left: 10px;
              height: 25px;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #136BAE;
              line-height: 25px;
            }
          }
          .card-content{
            display: flex;
            margin-top: 25px;
            margin-left: 20px;
            margin-right: 20px;
            .img{
              width: 96px;
              height: 72px;
              margin-right: 12px;
              img{
                width: 96px;
                height: 72px;
              }
            }
            .right{
              .address{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.7);
                line-height: 21px;
                margin-bottom: 10px;
              }
              .phone{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }
  .project-content {
    .title {
      height: 20px;
      font-size: 20px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 20px;
      margin-bottom: 12px;
      border-left: 12px solid #4f9cee;
      padding-left: 20px;
    }
    .project-list {
      overflow: hidden;
      margin: 20px 0;
      li {
        background-color: #f7f9fc;
        font-size: 16px;
        font-weight: 500;
        border-bottom: 1px solid #2e5c9a;
        padding: 20px;
        margin-bottom: 4px;
        a {
          color: #337ab7;
        }
      }
    }

  }
}
</style>

<style lang="less">
.body-content {
  .pagination-box {
    .el-pagination {
      button {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
      }
    }
    .el-pager {
      .number {
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
        &.active {
          background-color: #136BAE !important;
        }
      }
    }
  }
  .details{
    width: 100%;
    .universityName{
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      margin: 0 0 16px 20px;
    }
    .line{
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
    }
    .grid{
      display: flex;
      margin: 16px 20px;
      .grid1{
        width: 45%;
      }
      .grid2{
        width: 55%;
      }
    }
    .last{
      margin: 16px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/websiteSearch/index.vue